import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FlaskConical } from 'lucide-react';
import { Layout } from '@/components/layout/Layout';
import { EmptyHookTrackState } from '@/components/hook-track/EmptyHookTrackState';
import { useHookTrackStore } from '@/store/hook-track/hookTrackStore';
import { useAuth } from '@/hooks/useAuth';
import { Skeleton } from '@/components/ui/skeleton';
import { t } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';

const HookTrack = () => {
  useLanguage();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { tests, isLoading, fetchUserTests } = useHookTrackStore();

  // Verificar se existem testes ao carregar
  useEffect(() => {
    const userId = user?.id_user || user?.id;
    if (userId) {
      fetchUserTests(userId);
    }
  }, [user?.id_user, user?.id, fetchUserTests]);

  // Redirecionar para lista se existirem testes
  useEffect(() => {
    if (!isLoading && tests.length > 0) {
      navigate('/hook-track/list', { replace: true });
    }
  }, [tests, isLoading, navigate]);

  const handleCreateNewTest = () => {
    navigate('/hook-track/create');
  };

  // Mostrar skeleton enquanto carrega
  if (isLoading) {
    return (
      <Layout fixedSidebar>
        <div className="flex-1 flex flex-col overflow-hidden">
          <div className="flex-shrink-0 bg-transparent">
            <div className="max-w-[1600px] w-full mx-auto px-4 md:px-8 pt-4 md:pt-4 pb-4 md:pb-5">
              <Skeleton className="h-7 w-48" />
            </div>
            <div className="hidden lg:block h-px w-full" style={{ backgroundColor: 'rgba(0, 0, 0, 0.08)' }} />
          </div>
          <div className="flex-1 overflow-y-auto">
            <div className="max-w-[1600px] px-4 sm:px-6 pt-6 pb-6 mx-auto">
              <Skeleton className="h-64 w-full rounded-lg" />
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout fixedSidebar>
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header Premium */}
        <div className="flex-shrink-0 bg-transparent">
          <div className="max-w-[1600px] w-full mx-auto px-4 md:px-8 pt-4 md:pt-4 pb-4 md:pb-5">
            <div className="flex items-center gap-2.5">
              <FlaskConical className="h-[18px] w-[18px] text-[#2D6CF6]" strokeWidth={2} />
              <h1 className="text-[20px] md:text-[22px] font-semibold text-[#1E2330] tracking-tight leading-[1.2]">
                {t('hookTrack')}
              </h1>
            </div>
          </div>
          <div className="hidden lg:block h-px w-full" style={{ backgroundColor: 'rgba(0, 0, 0, 0.08)' }} />
        </div>

        <div className="flex-1 overflow-y-auto">
          <div className="max-w-[1600px] px-4 sm:px-6 pt-6 pb-6 mx-auto">
            <EmptyHookTrackState onCreateNew={handleCreateNewTest} />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default HookTrack;
